import { createFileRoute } from '@tanstack/react-router'
import { VerifyCertificatePage } from '@/pages/verify/ui/VerifyCertificatePage'

export const Route = createFileRoute('/verify/$token')({
  component: VerifyCertificateRoute,
})

function VerifyCertificateRoute() {
  const { token } = Route.useParams()
  return <VerifyCertificatePage token={token} />
}
